module.exports = __webpack_public_path__ + "static/McLaughlin-McNamee-ce93bf06f1c05f7537ac35f53196ec03.jpg";